
import { Component, Vue } from 'vue-property-decorator'
import { getHostList, addHost, putHost, delHost, stopHost, restartHost } from '@/api/admin'
import { IArticleData } from '@/api/types'
import { Form } from 'element-ui'

@Component({
  name: 'host'
})
export default class extends Vue {
  private list: IArticleData[] = []
  private listLoading = true
  private dialogFormVisible = false
  private title = '新增主机'
  private total = 0
  private sub = ''
  private listQuery = {
    page: 1,
    pagesize: 10,
    company: ''
  }
  private initForm = {
    company: '',
    hostState: '',
    hostCode: '',
    hostName: '',
    hostModel: '',
    simNumber: ''
  }
  private form = { ...this.initForm }
  private formLabelWidth = '120px'
  private rules = {
    company: [
      { required: true, message: '请输入企业名称', trigger: 'blur' }
    ],
    hostState: [
      { required: true, message: '请选择主机状态', trigger: 'change' }
    ],
    hostCode: [
      { required: true, message: '请输入主机编号', trigger: 'blur' }
    ],
    hostName: [
      { required: true, message: '请输入主机名称', trigger: 'blur' }
    ],
    hostModel: [
      { required: true, message: '请输入设备型号', trigger: 'blur' }
    ],
    simNumber: [
      { required: true, message: '请输入sim卡号', trigger: 'blur' }
    ]
  }
  created() {
    this.getList()
  }
  // 列表数据获取
  private async getList() {
    this.listLoading = true
    const { data } = await getHostList(this.listQuery)
    this.list = data.items
    this.total = data.total
    this.listLoading = false
  }
  // 新增 修改
  private async changeHandel(row:any) {
    this.dialogFormVisible = true
    if (row) {
      this.title = '修改主机'
      this.sub = 'put'
      this.form = row
    } else {
      this.title = '新增主机'
      this.sub = 'add'
      this.form = this.initForm
    }
  }
  private async submitHandle() {
    (this.$refs.form as Form).validate(async(valid) => {
      if (valid) {
        if (this.sub === 'add') {
          const res = await addHost(this.listQuery)
          if (res) {
            this.$message({
              type: 'success',
              message: '添加成功!'
            })
          }
        } else {
          const res = await putHost(this.listQuery)
          if (res) {
            this.$message({
              type: 'success',
              message: '修改成功!'
            })
          }
        }
        this.dialogFormVisible = false
      }
    })
  }
  // 停用主机
  private async stopHandel(id:any) {
    this.$confirm('确定要停用该主机？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = stopHost({ id })
      if (res) {
        this.getList()
        this.$message({
          type: 'success',
          message: '主机已停用!'
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '主机停用失败'
      })
    })
  }
  // 重启主机
  private async restartHandel(id:any) {
    this.$confirm('确定要重启该主机？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = restartHost({ id })
      if (res) {
        this.getList()
        this.$message({
          type: 'success',
          message: '主机重启中...!'
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '主机重启失败！'
      })
    })
  }
  // 删除
  private async delHandel(id:any) {
    this.$confirm('确定要删除该主机？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      const res = delHost({ id })
      if (res) {
        this.$message({
          type: 'success',
          message: '删除成功!'
        })
      }
    }).catch(() => {
      this.$message({
        type: 'info',
        message: '已取消删除'
      })
    })
  }
  // 分页切换
  private async handleCurrentChange(page:any) {
    this.listQuery.page = page
    this.getList()
  }
}
